import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextareaComponent } from "../../templates/template-textarea/template-textarea.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-bs8",
  imports: [TemplateTextareaComponent],
  templateUrl: "./prefix-bs8.component.html",
  styleUrl: "./prefix-bs8.component.less",
})
export class PrefixBs8Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 2000;
    this.characters = ALLOWED_CHARACTERS["bs8"];
  }
}
